import { useMemo, useCallback } from "react";
import { OverlayTrigger, Dropdown } from "react-bootstrap";
import { TooltipStandard } from "../../../Utility/TooltipStandard";

// import DeliveryMenuSelect from "../../DeliveryMenuSelect";

import {
  canFileClaim,
  canModify,
  canRequestReturn,
  canVoid,
} from "../../../../helpers/orderActionsUtilities";
import { openInNewTab } from "../../../../helpers/utilities";

import {
  clientsToBeExcludedFromPrintingLabels,
  // orderHistoryPreFilters,
  localStorageVariables,
  pages,
} from "../../../../constants";
import { basePath } from "../../../../config";

const checkIfClient = (decodeToken) =>
  Boolean(decodeToken?.ClientId && decodeToken?.ClientId !== 9999);

const constantFns = {
  modify: (event) => {
    const { deliveryId } = event.target.dataset;

    localStorage.setItem(localStorageVariables.lastModifying, deliveryId);

    openInNewTab(`${basePath}/modify-order/${deliveryId}`);
  },
  returnRequest: (event) => {
    const { deliveryId } = event.target.dataset;

    openInNewTab(`${basePath}/ActionCenter/Return/${deliveryId}`);
  },
  newDeliveryConcern: (event) => {
    const { deliveryId } = event.target.dataset;

    openInNewTab(`${basePath}/ActionCenter/DeliveryConcern/${deliveryId}`);
  },
  viewDeliveryConcern: (event) => {
    const { concernIncidentNo } = event.target.dataset;
    openInNewTab(`${basePath}${pages.viewConcern.url}/${concernIncidentNo}`);
  },

  newPostClaimConcern: (event) => {
    const { deliveryId } = event.target.dataset;

    // history.push(`/post-claim/${deliveryId}`);
    // history.push(`/ActionCenter/Claim/${deliveryId}`);
    openInNewTab(`${basePath}/ActionCenter/Claim/${deliveryId}`);
  },

  viewClaimConcern: (event) => {
    const { claimId } = event.target.dataset;
    openInNewTab(`${basePath}${pages.viewClaim.url}/${claimId}`);
  },
};

function DeliveryMenuSelect({
  deliveryId,
  linkId,
  invoiceNumber,
  creationDate,
  //   deliveryDate,
  deliveryStatus,
  deliveryType,
  //   buyoutOrReturn,
  //   returnDeliveryId,
  concernIncidentNo,
  claimID,
  clientDoesNotAllowCustomerReturns,
  returnRequestStatuses,
  decodedToken,

  // Functions
  onPrintLabelClick,
  onVoidClick,
}) {
  const isClient = useMemo(() => checkIfClient(decodedToken), [decodedToken]);

  const renderCustomePortalOptions = useCallback(() => {
    if (deliveryType === "Return") {
      return (
        <button
          type="button"
          // style={customerButtonStyle}
          onClick={onPrintLabelClick}
          className="btn btn-primary w-100"
          data-delivery-id={deliveryId}
        >
          Print Label
        </button>
      );
    }

    if (deliveryType !== "Regular") return null;

    if (deliveryStatus === "Open") {
      return (
        <OverlayTrigger
          flip
          placement="top"
          overlay={
            <TooltipStandard>
              Returns cannot be placed until the order has been picked up.
            </TooltipStandard>
          }
        >
          <button
            type="button"
            style={{
              fontSize: ".9rem",
            }}
            className="btn btn-primary disabled w-100"
            data-delivery-id={deliveryId}
          >
            Return
          </button>
        </OverlayTrigger>
      );
    }

    if (clientDoesNotAllowCustomerReturns) {
      return (
        <OverlayTrigger
          flip
          placement="top"
          overlay={
            <TooltipStandard>
              Unable to start a return.
              <br /> Please contact Dealer to initiate a return for this order.
            </TooltipStandard>
          }
        >
          <button
            type="button"
            style={{
              fontSize: ".9rem",
            }}
            data-delivery-id={deliveryId}
            className="btn btn-primary disabled w-100"
          >
            Return
          </button>
        </OverlayTrigger>
      );
    }

    if (returnRequestStatuses?.isReturnRequestedPending) {
      return (
        <button
          type="button"
          style={{
            fontSize: ".9rem",
          }}
          disabled
          className="btn btn-primary w-100"
        >
          Return Pending
        </button>
      );
    }

    return (
      <button
        type="button"
        style={{
          fontSize: ".9rem",
        }}
        className="btn btn-primary w-100"
        data-delivery-id={deliveryId}
        // onClick={onReturnRequestClick}
        onClick={constantFns.returnRequest}
      >
        Return
      </button>
    );
  }, [
    deliveryType,
    deliveryStatus,
    clientDoesNotAllowCustomerReturns,
    returnRequestStatuses?.isReturnRequestedPending,
    deliveryId,
    onPrintLabelClick,
  ]);

  // Client Portal Logic
  if (isClient) {
    return (
      <Dropdown align="end" drop="down">
        <Dropdown.Toggle id="dropdown-client-button">&#8942;</Dropdown.Toggle>

        <Dropdown.Menu
          popperConfig={{
            strategy: "fixed",
            modifiers: [
              { name: "preventOverflow", options: { boundary: "viewport" } },
            ],
          }}
        >
          {!clientsToBeExcludedFromPrintingLabels.includes(
            decodedToken.ClientId,
          ) && (
            <Dropdown.Item
              data-delivery-id={deliveryId}
              onClick={onPrintLabelClick}
            >
              Print Label
            </Dropdown.Item>
          )}

          {canModify(deliveryStatus, creationDate, deliveryType).ableTo && (
            <Dropdown.Item
              data-delivery-id={deliveryId}
              data-link-id={linkId}
              onClick={constantFns.modify}
            >
              Modify
            </Dropdown.Item>
          )}

          {canVoid(deliveryStatus, creationDate, deliveryType).ableTo && (
            <Dropdown.Item data-delivery-id={deliveryId} onClick={onVoidClick}>
              Void
            </Dropdown.Item>
          )}

          {concernIncidentNo ? (
            <Dropdown.Item
              // disabled
              // data-delivery-id={deliveryId}
              // data-invoice-number={invoiceNumber}
              // data-creation-date={creationDate}
              data-concern-incident-no={concernIncidentNo}
              // onClick={handleClickViewConcern}
              onClick={constantFns.viewDeliveryConcern}
            >
              View Existing Concern
            </Dropdown.Item>
          ) : (
            <Dropdown.Item
              data-delivery-id={deliveryId}
              data-invoice-number={invoiceNumber}
              data-creation-date={creationDate}
              // onClick={onDeliveryConcernRequestClick}
              onClick={constantFns.newDeliveryConcern}
            >
              New Delivery Concern
            </Dropdown.Item>
          )}

          {
            // (deliveryStatus !== "Open" || afterDeliveryDate) && ( //if we want to allow claims after the delivery date even if the order is open
            claimID ? (
              <Dropdown.Item
                data-claim-id={claimID}
                // onClick={handleClickViewClaim}
                onClick={constantFns.viewClaimConcern}
              >
                View Existing Claim
              </Dropdown.Item>
            ) : (
              canFileClaim(deliveryStatus, claimID).ableTo && (
                <>
                  <Dropdown.Item
                    data-delivery-id={deliveryId}
                    // onClick={onPostClaimClick}
                    onClick={constantFns.newPostClaimConcern}
                  >
                    New Claim
                  </Dropdown.Item>
                </>
              )
            )
          }

          {canRequestReturn(deliveryStatus, deliveryType).ableTo &&
            (returnRequestStatuses?.isReturnRequestedPending ? (
              <Dropdown.Item data-delivery-id={deliveryId} disabled>
                Return Request Pending
              </Dropdown.Item>
            ) : (
              <Dropdown.Item
                data-delivery-id={deliveryId}
                onClick={constantFns.returnRequest}
              >
                Return
              </Dropdown.Item>
            ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  // Customer Portal Logic
  return renderCustomePortalOptions();
}

export default DeliveryMenuSelect;
